import * as React from 'react';
import { IconButton, IconClose16, UIHeading2 } from '@cian/ui-kit';

import { InfoPlate } from '..';
import { TransportDepartmentIcon } from './parts';
import { TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH } from '../../../../../constants/infrastructure';

import * as styles from './TransportAccessibilitySidebar.css';

export interface ITransportAccessibilitySidebarProps extends React.PropsWithChildren {
  onClose: () => void;
  tabs: React.ReactNode;
  transportDepartmentLink: React.ReactNode;
}

export const TransportAccessibilitySidebar: React.FC<ITransportAccessibilitySidebarProps> = ({
  children,
  onClose,
  tabs,
  transportDepartmentLink,
}) => {
  return (
    <div className={styles['container']} style={{ width: `${TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH}px` }}>
      <div className={styles['close-button']}>
        <IconButton icon={<IconClose16 />} onClick={onClose} />
      </div>
      <div className={styles['header']}>
        <UIHeading2>Транспортная доступность</UIHeading2>
      </div>
      {tabs && (
        <div className={styles['tabs-wrapper']} data-testid="TransportAccessibilityTabs">
          {tabs}
        </div>
      )}
      <div className={styles['content-wrapper']}>
        {children}
        <div className={styles['data-from']}>
          <InfoPlate icon={<TransportDepartmentIcon />} content={transportDepartmentLink} withHorizontalMargin />
        </div>
      </div>
    </div>
  );
};
